import React from 'react';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { Advertiser as AdvertiserLayout } from '../../components/layouts';

class Index extends React.Component {

  render() {
    const passProps = pick(this.props, ['params', 'location', 'routes']);
  
    return (
      <div className='isAdvertiser'>
        <div className="md-skin">
          <AdvertiserLayout {...passProps}>
            {this.props.children}
          </AdvertiserLayout>
        </div>
      </div>
    );
  }
}

export default connect()(Index);
